module.exports = __webpack_public_path__ + "static/media/development.77d8e849.svg";